import { $api } from '@service/RequestService';
import { useQuery } from 'react-query';

import { crmModels } from '..';

export function useGoogleSheetsOneConfig({ id, enabled }: { id?: number; enabled?: boolean }) {
  const { data, ...arg } = useQuery<{ oneConfig: crmModels.GoogleSheetsAccountOneConfigType }>(
    ['google-sheets-one-config', id],
    async () => {
      const { data } = await $api.get(`/v1/crm/drive/config/${id}`);

      return { oneConfig: data?.data };
    },
    { enabled }
  );

  return { ...data, ...arg };
}
